export const BASIN_SESSION_ID = 'BasinSessionId'
export const BASIN_DAILY_ID = 'BasinDailyId'
export const BASIN_PERMANENT_ID = 'BasinPermanentId'

export const INSCALAR_SESSION_ID = 'InscalarSessionId'
